module.exports = __webpack_public_path__ + "img/104.7d57373b.png";